import { ModalWrapper } from "../../templates/ModalWrapper"
import styles from "./styles.module.scss"
import CloseModalButton from "../../buttons/CloseModalButton"
import classNames from "classnames"
import { ModalCheckbox } from "../../atoms/ModalCheckbox"
import { makeAutoObservable } from "mobx"
import { observer } from "mobx-react-lite"
import { useMemo } from "react"

class ConfirmationModalStore {
  dontShow: boolean

  constructor(doNotShowText?: string) {
    this.dontShow = doNotShowText ? localStorage.getItem(doNotShowText) === "true" : false

    makeAutoObservable(this)
  }

  setDontShow(value: boolean, doNotShowText: string) {
    this.dontShow = value
    localStorage.setItem(doNotShowText, value.toString())
  }
}

export const ConfirmationModal = observer(function ConfirmationModal({
  title,
  description,
  onConfirm,
  isLoading,
  closeModal,
  doNotShowText,
  confirmButtonText,
  testId,
  isPrimary = false,
  singleButton = false,
}: {
  title: string
  description: string
  onConfirm: () => void
  closeModal: () => void
  doNotShowText?: string
  isLoading: boolean
  confirmButtonText: string
  testId: string
  isPrimary?: boolean
  singleButton?: boolean
}) {
  const state = useMemo(() => new ConfirmationModalStore(doNotShowText), [])

  return (
    <ModalWrapper>
      <div className={styles.container}>
        <CloseModalButton
          onClick={closeModal}
          className={styles.closeButton}
          testId={`${testId}-close-button`}
        />
        <div className={styles.header}>
          <h2>{title}</h2>
        </div>
        <p dangerouslySetInnerHTML={{ __html: description }} />
        {doNotShowText && (
          <div className={styles.checkboxContainer}>
            <ModalCheckbox
              label="Don't show this modal again"
              textClassName={styles.checkboxText}
              isChecked={state.dontShow}
              testID="dont-show-select-cruise-modal-checkbox"
              onPress={() => state.setDontShow(!state.dontShow, doNotShowText)}
            />
          </div>
        )}
        <div className={styles.buttonContainer}>
          {!singleButton && (
            <button
              type="button"
              className={styles.cancelButton}
              onClick={closeModal}
              disabled={isLoading}
              data-testid={`${testId}-cancel-button`}
            >
              Cancel
            </button>
          )}
          <button
            type="button"
            className={classNames(styles.confirmButton, isPrimary && styles.primary)}
            disabled={isLoading}
            onClick={onConfirm}
            data-testid={`${testId}-confirm-button`}
          >
            {confirmButtonText}
          </button>
        </div>
      </div>
    </ModalWrapper>
  )
})
